export const getRandom = (max: number, min = 0) => Math.random() * (max - min) + min;
export const getRandomInt = (max: number, min = 0) => Math.floor(getRandom(max, min));
